module.exports = __webpack_public_path__ + "static/img/bottom2.43f12b8e.png";